import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const DriverTraccarApi = createApi({
  reducerPath: "driverTraccar",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getAllDrivers: builder.query({
      query: () => "/drivers?all=true",
    }),
    getDriversByDevice: builder.query({
      query: (id) => `/drivers?deviceId=${id}`,
    }),
    getDriversByUser: builder.query({
      query: (id) => `/drivers?userId=${id}`,
    }),
    getFuelCostSummary: builder.query({
      query: ({
        from: startdate,
        to: enddate,
        page: currentpage,
        pageSize: limit,
        sortBy,
        sortOrder,
        search,
      }) =>
        `/devices/summary?from=${startdate}&to=${enddate}}&page=${currentpage}&pageSize=${limit}${
          sortBy ? `&sortBy=${sortBy}` : ""
        }${sortOrder ? `&sortOrder=${sortOrder}` : ""}${
          search ? `&search=${search}` : ""
        }`,
    }),
  }),
});

export const {
  useGetAllDriversQuery,
  useGetDriversByDeviceQuery,
  useGetDriversByUserQuery,
  useGetFuelCostSummaryQuery,
} = DriverTraccarApi;
